//chapter1
export default {
    id : 6,//chapter number
    title : '06. 마킹 공정(Marking) (2)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/06/videos/a06.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '레이저의 특징',
                '레이저 마킹 장비 구성',
                '레이저 빔의 동작상태에 따른 레이저 마킹기 분류',
            ],
            body2 : [
                '레이저의 특징에 대해 설명할 수 있다.',
                '레이저 마킹 장비 구성에 대해 설명할 수 있다.',
                '레이저 빔의 동작상태에 따른 레이저 마킹기 분류에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/06/videos/06.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '레이저를 이용한 마킹 작업은 마킹 불량이 거의 발생하지 않는 공정이다.',//html available
                    answer : "2",
                    explain : '레이저를 이용한 마킹 작업에서는 다양한 형태의 불량이 발생할 수 있으므로 정밀한 셋팅 작업이 필요된다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '레이저 마킹작업이 제대로 진행되는지 육안으로 확인하는 과정이 필요하다.',//html available
                    answer : "2",
                    explain : '레이저를 직접 눈으로 보거나 피부에 노출되는 것은 위험하므로 직접 보아야할 경우에는 반드시 보안경을 착용한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>레이저의 특징<br>
                        - 증폭된 빛으로 직진성과 에너지를 갖추어서 인쇄, 절단에 사용되며 활용분야 증가 <br>
                        - Laser 광은 직진성이 있고 단색성이 좋음<br>
                        - Laser 광은 에너지 밀도가 높음<br>
                        - Laser 광은 집광성이 좋음(집광성 : 빛의 모음)</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>레이저 마킹 장비 구성<br>
                        - 레이저 발진기<br>
                        - 빔 expander<br>
                        - scanning system(galvanometer와 deflector(전향기))<br>
                        - Q-switch<br>
                        - 촛점 렌즈(f-렌즈, flat-field 렌즈)와 컨트롤러 및 소프트웨어</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>레이저 빔의 동작상태에 따른 레이저 마킹기 분류<br>
                        - 빔 동작 상태에 따라 빔 scanning(빔 이동형) 방법과 빔 고정 방법으로 분류 가능<br>
                        - 각 시스템의 특징을 보면 빔 scanning 타입은 제조번호와 같이 매번 변화하는 마킹 형상을 따라 신속하게 대응을 할 수 있는 특징이 있으며, 마스크 타입에 비교하여 보다 정밀한 마킹이 가능하나 scanning을 하기위한 galvanometer 컨트롤러의 조정기술의 요구됨</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/06/videos/a06.mp4',
        },
    ]
}